export const PdfIcon: React.FC<{ color?: string; size?: number }> = ({
  color = "#E94848",
  size = 13,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5718 0C14.102 0 14.6105 0.210507 14.9855 0.585255L21.6135 7.20826C21.9889 7.58338 22.1998 8.09231 22.1998 8.62301V21.2C22.1998 22.7464 20.9211 24 19.3438 24H4.6558C3.07848 24 1.7998 22.7464 1.7998 21.2V2.8C1.7998 1.2536 3.07848 0 4.6558 0H13.5718Z"
      fill={color}
    />
    <g filter="url(#filter0_d_12056_29104)">
      <path
        d="M20.7544 6.94184C21.0674 7.25741 20.8439 7.79395 20.3994 7.79395H17.3996C15.8532 7.79395 14.4582 6.43376 14.4582 4.92599V1.80806C14.4582 1.36162 14.9988 1.13899 15.3132 1.45595L20.7544 6.94184Z"
        fill="white"
        fillOpacity="0.24"
        shapeRendering="crispEdges"
      />
    </g>
    <path
      d="M9.64 9.59375C9.12785 9.59375 8.70667 10.0149 8.70667 10.5271C8.70667 11.1638 9.06041 11.9542 9.43292 12.6971C9.14175 13.6086 8.81133 14.5853 8.38875 15.4096C7.52383 15.749 6.75249 16.0012 6.28875 16.375C6.28152 16.3824 6.2747 16.3902 6.26833 16.3983C6.09887 16.5716 6 16.8076 6 17.0604C6 17.5726 6.42118 17.9937 6.93333 17.9937C7.18308 17.9937 7.42414 17.9006 7.59833 17.7225C7.60436 17.7179 7.6102 17.713 7.61583 17.7079C7.9572 17.3003 8.3597 16.5609 8.71833 15.885C9.54487 15.5599 10.4112 15.229 11.2471 15.0304C11.8573 15.5222 12.7401 15.8471 13.4667 15.8471C13.9788 15.8471 14.4 15.4259 14.4 14.9137C14.4 14.4016 13.9788 13.9804 13.4667 13.9804C12.884 13.9804 12.0374 14.1884 11.39 14.4062C10.8653 13.9136 10.3832 13.2984 10.0367 12.6446C10.2842 11.8819 10.5733 11.1188 10.5733 10.5271C10.5733 10.0149 10.1522 9.59375 9.64 9.59375ZM9.64 10.1537C9.8495 10.1537 10.0133 10.3176 10.0133 10.5271C10.0133 10.8072 9.86333 11.323 9.68958 11.8775C9.45742 11.3381 9.26667 10.8205 9.26667 10.5271C9.26667 10.3176 9.4305 10.1537 9.64 10.1537ZM9.80042 13.3475C10.0811 13.794 10.4099 14.2095 10.7687 14.5783C10.2153 14.7297 9.6747 14.9236 9.14125 15.1267C9.3989 14.5451 9.60516 13.9417 9.80042 13.3475ZM13.4667 14.5404C13.6762 14.5404 13.84 14.7042 13.84 14.9137C13.84 15.1233 13.6762 15.2871 13.4667 15.2871C13.0461 15.2871 12.4483 15.0972 11.9704 14.8321C12.5189 14.677 13.1175 14.5404 13.4667 14.5404ZM7.89583 16.2117C7.63337 16.6802 7.37248 17.1174 7.19 17.3375C7.12767 17.3971 7.04474 17.4337 6.93333 17.4337C6.72383 17.4337 6.56 17.2699 6.56 17.0604C6.56 16.9618 6.6019 16.8639 6.65917 16.8008C6.87811 16.6314 7.35444 16.4283 7.89583 16.2117Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_12056_29104"
        x="12.458"
        y="1.30664"
        width="10.4424"
        height="10.4873"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_12056_29104"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_12056_29104"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
